// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"acf17278","455":"146b20ff","977":"f7aafa7f"}[chunkId] + ".chunk.js";
};